webpackJsonp([236235775741549],{

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.IndexPageQuery = undefined;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(93);
	
	var _components = __webpack_require__(45);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _getContents = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	    var data = _ref.data;
	
	    if (!data) {
	        return _react2.default.createElement(
	            'div',
	            null,
	            'Landing page'
	        );
	    }
	
	    var page = data.page.edges[0].node;
	    var insights = (0, _getContents.stripNode)(data.insights.edges);
	    var locations = (0, _getContents.stripNode)(data.locations.edges);
	    var regions = (0, _getContents.stripNode)(data.regions.edges);
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'green-dividers' },
	        _react2.default.createElement(
	            _reactHelmet.Helmet,
	            null,
	            _react2.default.createElement('body', { className: 'landingpage' })
	        ),
	        page.modules.map(function (module, i) {
	            return _react2.default.createElement(_components2.default, {
	                key: i,
	                content: module,
	                insights: insights,
	                locations: locations,
	                regions: regions
	            });
	        })
	    );
	};
	
	exports.default = IndexPage;
	
	/*
	
	query PageQusdasdasdsdfry {
	  page: allMarkdownRemark (filter: { frontmatter:  { contenttype: { eq: "landing_page"}}}){
	*/
	
	var IndexPageQuery = exports.IndexPageQuery = '** extracted graphql fragment **';
	
	// date(formatString: "MMMM DD, YYYY")

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-landingpage-template-js-58c56d2982c18734042d.js